import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiText } from '@shared/ui';

import cls from './RequestsTableHeader.module.css';

interface RequestsTableHeaderProps {
    classes?: string;
}

export const RequestsTableHeader = ({ classes }: RequestsTableHeaderProps) => {
    const { t } = useTranslation();
    return (
        <div className={cn(cls.RequestsTableHeader, classes)}>
            <div />
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.position')}
                </UiText>
            </div>
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.plan')}
                </UiText>
            </div>
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.put')}
                </UiText>
            </div>
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.count')}
                </UiText>
            </div>
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.left')}
                </UiText>
            </div>
            <div>
                <UiText variant="mediumPlain">
                    {t('RequestsTableHeader.return.Flex.header.UiText.unit')}
                </UiText>
            </div>
        </div>
    );
};
